import { Injectable } from '@angular/core';
import { AuthToken } from '../models/auth-token';
import { isNil, Nillable } from '@web/utils';
import { AuthTokenNotFoundException } from '../exceptions/auth-token-not-found.exception';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenStorage {
  private token: Nillable<AuthToken>;

  public store(token: AuthToken): void {
    this.token = token;
  }

  public clear(): void {
    this.token = null;
  }

  public fetch(): AuthToken {
    if (isNil(this.token)) {
      throw new AuthTokenNotFoundException();
    }

    return this.token;
  }
}
